import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }

import { ref, watchEffect } from "vue";
import { useRouter } from "vue-router";
//import { where, query, getDocs } from "firebase/firestore";
import { ref as storageRef, getDownloadURL } from "firebase/storage";
import { storage } from '@/lib/firebase';
import { STORAGE_PATHS } from '@/lib/constants';
import type { QwikUCard } from '@/types';

// State management

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter();
const shareid = ref<string | null>(null);
const mysmartcard = ref<QwikUCard | null>(null);
const error = ref<Error | null>(null);

// Cache for photo URLs to improve performance
const photoUrlCache = new Map<string, string>();

/**
 * Fetches and caches photo URLs
 */
const fetchPhotoUrl = async (photoUrl: string): Promise<string> => {
  if (photoUrlCache.has(photoUrl)) {
    return photoUrlCache.get(photoUrl)!;
  }

  const imageRef = storageRef(storage, `${STORAGE_PATHS.USER_IMAGES}/${photoUrl}`);
  try {
    const url = await getDownloadURL(imageRef);
    photoUrlCache.set(photoUrl, url);
    return url;
  } catch (err) {
    console.error("Error fetching image URL:", err);
    return '';
  }
};


// Initialize routing and data fetching
watchEffect(async () => {
  try {
    await router.isReady();
    const adParam = router.currentRoute.value.params.Ad;
    shareid.value = typeof adParam === 'string' ? adParam : null;

  } catch (err) {
    error.value = err as Error;
    console.error("Initialization error:", err);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view, { shareid: shareid.value }, null, 8, ["shareid"])
  ]))
}
}

})